import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import type { PropsWithClassName } from '../../../../types';
import type { ButtonData } from './RssButton';
import { RssButton } from './RssButton';

export function RssButtons({ className }: PropsWithClassName) {
  const {
    RssUrl,
    applePodcastUrl,
    spotifyUrl,
    googlePodcastUrl,
    stitcherUrl,
    soundcloudUrl,
    overcastUrl,
    castboxUrl,
    pocketCastsUrl,
    castroUrl,
    sourceType
  } = useSettings();

  if (sourceType !== 'rss') {
    return null;
  }

  const buttons: ButtonData[] = [
    {
      label: 'RSS',
      actionUrl: RssUrl,
      icon: 'rss'
    },
    {
      label: 'Apple Podcasts',
      actionUrl: applePodcastUrl,
      icon: 'applePodcast'
    },
    {
      label: 'Spotify',
      actionUrl: spotifyUrl,
      icon: 'spotify'
    },
    {
      label: 'Google Podcasts',
      actionUrl: googlePodcastUrl,
      icon: 'googlePodcast'
    },
    {
      label: 'Stitcher',
      actionUrl: stitcherUrl,
      icon: 'stitcher'
    },
    {
      label: 'SoundCloud',
      actionUrl: soundcloudUrl,
      icon: 'soundcloud'
    },
    {
      label: 'Overcast',
      actionUrl: overcastUrl,
      icon: 'overcast'
    },
    {
      label: 'Castbox',
      actionUrl: castboxUrl,
      icon: 'castbox'
    },
    {
      label: 'Pocket Casts',
      actionUrl: pocketCastsUrl,
      icon: 'pocketCasts'
    },
    {
      label: 'Castro',
      actionUrl: castroUrl,
      icon: 'castro'
    }
  ];

  return (
    <ButtonsComponent className={className}>
      {buttons.map(
        (item) => !!item.actionUrl && <RssButton data={item} key={item.label} />
      )}
    </ButtonsComponent>
  );
}

export const ButtonsComponent = styled.div`
  display: flex;
`;
